import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

/**
 * A 402 means the backend's SubscriptionAccessMiddleware cut access because the trial expired
 * or the subscription was canceled. Redirect straight to the billing page instead of letting
 * the raw error surface wherever the request happened to originate from.
 */
export const subscriptionInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 402 && !router.url.startsWith('/billing')) {
        router.navigate(['/billing']);
      }

      return throwError(() => error);
    }),
  );
};
